import { render, staticRenderFns } from "./StoreColor.vue?vue&type=template&id=2b1d1612&"
import script from "./StoreColor.vue?vue&type=script&lang=ts&"
export * from "./StoreColor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports